<template>
    <q-card>
        <q-toolbar>
            <q-toolbar-title class="text-center">
                Reset Password
            </q-toolbar-title>
        </q-toolbar>
        <q-separator />
        <form v-if="!done" @submit.prevent="reset">
            <q-card-section>
                <p class="text-subtitle1">
                    Please enter your new password below:
                </p>
                <password-input
                        label="Password"
                        v-model="password"
                        outlined
                />
            </q-card-section>
            <q-card-actions align="center">
                <async-btn
                        type="submit"
                        label="Reset"
                        :task="task"
                        color="primary"
                        class="full-width"
                />
            </q-card-actions>
        </form>
        <q-card-section v-else class="animated fadeIn">
            <message>Your password has been reset!</message>
            <q-btn
                    :to="{name: 'login'}"
                    color="primary"
                    label="Click here to login"
                    class="full-width q-mt-md"
            />
        </q-card-section>
    </q-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import PasswordInput from '@/components/form/PasswordInput.vue';
import Message from '@/components/message/Message.vue';
import { resetPassword } from './user';

interface Data {
  password: string,
  done: boolean,
  task: Promise<void>|null,
}

export default defineComponent({
  components: {
    AsyncBtn,
    PasswordInput,
    Message,
  },
  props: {
    token: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      password: '',
      done: false,
      task: null,
    };
  },
  methods: {
    reset() {
      this.task = resetPassword(this.token, this.password);
      this.task.then(() => {
        this.done = true;
      });
    },
  },
});
</script>
